import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography
} from '@material-ui/core';
import Groups from '@material-ui/icons/Groups';
//import { blue } from '@material-ui/core/colors';
import { useEffect, useState } from 'react';

const TotalPatients = (props) => {
  const [activeCount, setActiveCount] = useState(0);
  const { details } = props;
  useEffect(() => {
    if (details && details.length >= 0) {
      let r = 0;
      details.forEach(item => {
        // if (item.status === 1) {
        //   r++;
        // }
        r++;
      });
      setActiveCount(r);
    }
  }, [details]);

  return (
    <Card
      sx={{
        height: '100%',
        boxShadow: 12
      }}
      {...props}
    >
      <CardContent sx={{ boxShadow: '' }}>
        <Grid
          container
          spacing={3}
          sx={{ justifyContent: 'center' }}
        >
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: '#C43ABA',
                height: 56,
                width: 56
              }}
            >
              <Groups />
            </Avatar>
          </Grid>
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              TOTAL PATIENTS
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
              sx={{ textAlign: 'center' }}
            >
              {activeCount}
            </Typography>
          </Grid>
          
        </Grid>
      </CardContent>
    </Card>
  )
};

export default TotalPatients;
